import script from "./AddCatalogProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCatalogProduct.vue?vue&type=script&setup=true&lang=js"

import "./AddCatalogProduct.vue?vue&type=style&index=0&id=6d42665c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d42665c"]])

export default __exports__